import api from './api.service';

export const spotPurchaseService = {
  listEligiblePrs: async () => {
    const res = await api.get('/procurement/spot-purchase/eligible-prs');
    return res.data?.data ?? res.data;
  },
  listMine: async () => {
    const res = await api.get('/procurement/spot-purchase/mine');
    return res.data?.data ?? res.data;
  },
  listEligiblePurchasers: async () => {
    const res = await api.get('/procurement/spot-purchase/eligible-purchasers');
    return res.data?.data ?? res.data;
  },
  claim: async (prId: string) => {
    const res = await api.post(`/procurement/spot-purchase/prs/${prId}/claim`);
    return res.data?.data ?? res.data;
  },
  listAssignments: async (prId: string) => {
    const res = await api.get(`/procurement/spot-purchase/prs/${prId}/assignments`);
    return res.data?.data ?? res.data;
  },
  assign: async (prId: string, purchaser_user_ids: string[]) => {
    const res = await api.post(`/procurement/spot-purchase/prs/${prId}/assignments`, {
      purchaser_user_ids,
    });
    return res.data?.data ?? res.data;
  },
  unassign: async (prId: string, purchaserUserId: string) => {
    const res = await api.delete(
      `/procurement/spot-purchase/prs/${prId}/assignments/${purchaserUserId}`
    );
    return res.data?.data ?? res.data;
  },
  getAvailability: async (prId: string) => {
    const res = await api.get(`/procurement/spot-purchase/prs/${prId}/availability`);
    return res.data?.data ?? res.data;
  },
  listReservations: async (prId: string) => {
    const res = await api.get(`/procurement/spot-purchase/prs/${prId}/reservations`);
    return res.data?.data ?? res.data;
  },
  reserve: async (prId: string, pr_line_id: string, qty: number) => {
    const res = await api.post(`/procurement/spot-purchase/prs/${prId}/reservations`, {
      pr_line_id,
      qty,
    });
    return res.data?.data ?? res.data;
  },
  releaseReservation: async (reservationId: string, as_supervisor = false, reason?: string) => {
    const res = await api.post(`/procurement/spot-purchase/reservations/${reservationId}/release`, {
      as_supervisor,
      reason,
    });
    return res.data?.data ?? res.data;
  },
  listOffers: async (prId: string) => {
    const res = await api.get(`/procurement/spot-purchase/prs/${prId}/offers`);
    return res.data?.data ?? res.data;
  },
  upsertOffer: async (prId: string, payload: Record<string, unknown>) => {
    const res = await api.post(`/procurement/spot-purchase/prs/${prId}/offers`, payload);
    return res.data?.data ?? res.data;
  },
  deleteOffer: async (offerId: string) => {
    const res = await api.delete(`/procurement/spot-purchase/offers/${offerId}`);
    return res.data?.data ?? res.data;
  },
  submit: async (prId: string, client_submission_key: string, offer_ids?: string[]) => {
    const res = await api.post(`/procurement/spot-purchase/prs/${prId}/submit`, {
      client_submission_key,
      offer_ids,
    });
    return res.data?.data ?? res.data;
  },
  searchSuppliers: async (search?: string, limit = 30) => {
    const res = await api.get('/procurement/spot-purchase/suppliers', {
      params: { search: search || undefined, limit },
    });
    const data = res.data?.data ?? res.data;
    return Array.isArray(data) ? data : data?.suppliers ?? [];
  },
  listSupplierShares: async (prId: string) => {
    const res = await api.get(`/procurement/spot-purchase/prs/${prId}/supplier-shares`);
    return res.data?.data ?? res.data;
  },
  createSupplierShare: async (
    prId: string,
    payload: {
      supplier_id: string;
      pr_line_ids: string[];
      expires_in_hours?: number;
      notes?: string;
    }
  ) => {
    const res = await api.post(`/procurement/spot-purchase/prs/${prId}/supplier-shares`, payload);
    return res.data?.data ?? res.data;
  },
  revokeSupplierShare: async (shareId: string) => {
    const res = await api.post(`/procurement/spot-purchase/supplier-shares/${shareId}/revoke`);
    return res.data?.data ?? res.data;
  },
};

export default spotPurchaseService;
